import http from '../_http'

const setting = {
  //default
  listSetting: (m) => { return http.post(`manager/setting/setting/list`, m); },
  detailSetting: (m) => { return http.get(`manager/setting/setting/${m.id}`); },

  //crud
  insertSetting: (m) => { return http.post(`manager/setting/setting`, m); },
  updateSetting: (m) => { return http.put(`manager/setting/setting`, m); },
  deleteSetting: (m) => { return http.delete(`manager/setting/setting/${m.id}`); },

  //custom
  customSetting: (m) => { return http.get(`manager/setting/setting/custom`, m); },
}

export default setting

export { setting }